import { useTranslations } from 'next-intl'
import { Link } from '@repo/web-ui/components/link'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { BirthdaysIcon } from '../../../assets/icons'
import { IconArrowForward } from '@repo/design-system-cf/components/icons'

const DUMMY_NUMBERS = {
  birthdays: 311_224,
}

export function BirthdayBox({ slug }: { slug: string }) {
  const t = useTranslations('pages.clubhouse')

  return (
    <Link
      href={`${AppRoutes.CLUBHOUSE}${slug}`}
      className={
        'rounded-[12px] col-span-1 flex flex-row items-center justify-start gap-3 border border-[#1313151F] bg-cf-orange-50 shadow-[0px_2px_4px_0px_#0000001A] p-4 hover:shadow-none'
      }
    >
      <BirthdaysIcon className="size-6 sm:size-14 shrink-0 text-cf-orange-500" />
      <div className="flex justify-between items-center w-full">
        <div className="flex sm:flex-col gap-2 sm:gap-0 items-center sm:items-start">
          <p className="text-cf-grey-1000 text-[18px] font-bold leading-[26px] md:text-[29px] md:leading-[38px]">
            {DUMMY_NUMBERS.birthdays.toLocaleString()}
          </p>
          <p className="text-14 font-medium text-cf-grey-800">{t('detailsbox.birthdays')}</p>
        </div>
        <IconArrowForward className="size-[18px] text-cf-purple-900 sm:hidden" />
      </div>
    </Link>
  )
}
